import * as v from 'valibot'

import {
  DISCOVER_CREATORS,
  DISCOVER_DURATION_FILTER_VALUES,
  DISCOVER_FORMAT_FILTERS,
  DiscoverFormatFilter,
} from '../types'

function optionalStringList<T extends string>(
  itemSchema: v.GenericSchema<T, T>,
) {
  return v.pipe(
    v.optional(v.union([v.array(itemSchema), itemSchema])),
    v.transform((value): T[] => {
      if (!value) {
        return []
      }

      return Array.isArray(value) ? value : [value]
    }),
  )
}

export const discoverChannelsSearchSchema = v.object({
  channels: v.fallback(optionalStringList(v.string()), []),
  creator: v.optional(v.picklist(DISCOVER_CREATORS)),
  duration: v.optional(v.picklist(DISCOVER_DURATION_FILTER_VALUES)),
  formats: v.fallback(
    optionalStringList(v.picklist(DISCOVER_FORMAT_FILTERS)),
    [] as DiscoverFormatFilter[],
  ),
  query: v.optional(v.string()),
  state: v.optional(
    v.picklist(['not_started', 'started', 'completed'] as const),
  ),
})

export type DiscoverChannelsSearch = v.InferOutput<
  typeof discoverChannelsSearchSchema
>

export const DEFAULT_DISCOVER_CHANNELS_SEARCH: DiscoverChannelsSearch = {
  channels: [],
  creator: undefined,
  duration: undefined,
  formats: [],
  query: '',
  state: undefined,
}

export const discoverChannelsSearchParamKeys = Object.keys(
  discoverChannelsSearchSchema.entries,
) as Array<keyof DiscoverChannelsSearch>

export function hasDiscoverChannelsFilterSearch(
  search: Partial<DiscoverChannelsSearch>,
) {
  return discoverChannelsSearchParamKeys.some((key) => {
    const value = search[key]

    if (value === undefined || value === null || value === '') {
      return false
    }

    return !(Array.isArray(value) && value.length === 0)
  })
}
